import './index.scss';

import React from 'react';

interface IChartNotFoundProps {
  text: string;
}

const ChartNotFound: React.FC<IChartNotFoundProps> = ({ text }) => {
  return (
    <div className="mm-pair-chart-not-found">
      <span className="caption">{text}</span>
    </div>
  );
};

export { ChartNotFound };
